import { transformData, transformDataTimeSlot } from '../utils';
import { uploadImage } from '@/firebase';
import { createDownloadableLink } from '@/helpers';
import { cloneDeep, get, isEmpty } from 'lodash';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getLocationSuccess: (data) => ({ data }),
  getLocation:
    (search, paging, sortOption = {}, filterOption = {}, cb) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().location.paging;
      let { result, status } = await Api.post(`locations/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...sortOption,
        ...filterOption,
      });
      if (status === 200) {
        const { list, ...restParams } = result;
        const baseIndex = pagingData.pageIndex * pagingData.pageSize + 1;
        const dataAddIndex = list.map((item, index) => ({
          ...item,
          index: baseIndex + index,
        }));

        locationDispatcher.getLocationSuccess({
          ...restParams,
          list: dataAddIndex,
        });
        cb && cb(list);
      }
    },
  getAllLocation:
    (callback) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(`locations/filter`, {});
      if (status === 200) {
        callback && callback(result.list);
      }
    },
  setState: (state, value) => ({ state, value }),
  createLocation:
    (data, callbackSuccess, callBackError) =>
    async ({ Api }) => {
      let params = { ...data };
      if (!isEmpty(data?.imageUrl)) {
        const timeStamp = new Date().getTime();
        data.fileName = timeStamp + get(data, 'imageUrl.name');

        let storageUrl = await uploadImage(data.imageUrl, timeStamp);
        params.imageUrl = storageUrl;
      }

      const { status } = await Api.post('locations', params);
      locationDispatcher.setState('loading', false);
      if (status === 200) {
        callbackSuccess && callbackSuccess();
      }
      callBackError && callBackError();
    },
  editLocation:
    (id, payload, callbackSuccess, callBackError) =>
    async ({ Api }) => {
      const data = cloneDeep(payload);
      if (data.imageUrl?.constructor === File) {
        const timeStamp = new Date().getTime();
        data.fileName = timeStamp + get(data, 'imageUrl.name');

        const storageUrl = await uploadImage(data.imageUrl);
        data.imageUrl = storageUrl;
      }

      const { result, status } = await Api.put(`locations/${id}`, data);
      locationDispatcher.setState('loading', false);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
      callBackError && callBackError();
    },
  deleteLocation:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.delete(`locations/${id}`);
      if (status === 200) {
        customToast('success', 'Location deleted');
        callbackSuccess && callbackSuccess();
      }
    },
  updateStatus:
    ({ id, value, cb }) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.put(`locations/${id}/status`, {
        status: value,
      });
      if (status === 200) {
        customToast('success', 'Update status location success');
        cb && cb();
      }
    },
  getDetailLocation:
    (id, callbackSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`locations/${id}`);
      if (status === 200) {
        const newResult = transformData(result);
        callbackSuccess && callbackSuccess(newResult);
      }
    },
  getExportExcel:
    (params) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(`locations/exports/csv`, {
        ...params,
      });
      status === 200 && createDownloadableLink(result, 'locations-report');
    },
  getDetailLocationTimeSlot:
    (data, callbackSuccess) =>
    async ({ Api }) => {
      const { id, startDate } = data;

      const { status, result } = await Api.post(`location-time-slots/filter`, {
        ...data,
        locationId: id,
        viewAll: true,
      });
      if (status === 200) {
        const newResult = transformDataTimeSlot(result);
        callbackSuccess && callbackSuccess(newResult);
      }
    },
  getHomebasedLocations:
    (callbackSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`health-screenings/personal`, {
        packageType: 'HBS',
      });
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getHomebasedTimeSlot:
    (data, callbackSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.post(`location-time-slots/filter`, {
        locationId: data.locationId,
        date: data.date,
      });
      if (status === 200) {
        callbackSuccess && callbackSuccess(transformDataTimeSlot(result));
      }
    },
  getLocationByProject:
    (projectId, callbackSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`locations/filter-by-project`, {
        projectId,
      });
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getLocationFollowUp:
    (callback) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`locations/follow-up`);
      if (status === 200) callback && callback(result);
    },
  getLocationPlatoNames:
    (callback) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`locations/plato-names`);
      if (status === 200) callback && callback(result);
    },
};

const locationDispatcher = synthesize('location', mapDispatchToAC);
export default locationDispatcher;
